//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../components/ImageUploader";
import util from '@/lib/util';

export default {
    name: "workOrderInfo",
    components: {ImageUploader},
    data() {
        return {
            id: 0,
            workOrder: {
                fileIds: [],
                comments: []
            },
            roomNum: '',
            downloadUrl: util.ApiUrl + '/file/download/',
            show: false,
        }
    },
    methods: {
        getRepairRecordById() {
            this.$toast.loading({
                duration: 0,
                message: ''
            });
            this.$store.dispatch({
                type: 'workOrder/getWorkOrderById',
                id: this.id
            }).then(() => {
                this.workOrder = this.$store.state.workOrder.workOrderInfo;
            }).finally(() => {
                this.$toast.clear();
            });
        },
        onConfirm() {
            this.onDelete();
        },
        onShowDialog(id) {
            this.show = true;

        },
        onDelete() {

        },
        repairComment() {
            // this.$router.push({path: '/repairComment/' + this.id})
        },
        onClickTel() {
            window.location.href = 'tel://400-012-7878'
        },
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getRepairRecordById();
        }

    }
}
